import React from 'react'
import { hydrateRoot } from 'react-dom/client'
import App from './App'

function getQueryParams() {
  const searchParams = new URLSearchParams(window.location.search);
  const params = {};
  
  for (const [key, value] of searchParams.entries()) {
    params[key] = value;
  }
  
  return params;
}

const get = getQueryParams();

const ajax_data = window.__MODX_DATA__ || {}
const data = ajax_data?.site_data || {}

console.log('Client hydration:', ajax_data)

hydrateRoot(
  document.getElementById('stomahelp'),
  <App
    ajax_data={ajax_data}
    data={data}
    get={get}
  />
)